<nav>
    <section id='upperNav'>
        <div id="logo-container">
            <a routerLink="/home"><svg class="yt-logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 492 110" xmlns:v="https://vecta.io/nano"><path d="M154.3 17.5a19.6 19.6 0 0 0-13.8-13.8C128.4.4 79.7.4 79.7.4S31 .5 18.9 3.8A19.6 19.6 0 0 0 5.1 17.6C1.44 39.1.02 71.86 5.2 92.5A19.6 19.6 0 0 0 19 106.3c12.1 3.3 60.8 3.3 60.8 3.3s48.7 0 60.8-3.3a19.6 19.6 0 0 0 13.8-13.8c3.86-21.53 5.05-54.27-.1-75z" fill="white"/><path fill="#1E1E1E" d="M64.2 78.4L104.6 55 64.2 31.6z"/><g fill="white"><path d="M227.9 99.7c-3.1-2.1-5.3-5.3-6.6-9.7s-1.9-10.2-1.9-17.5v-9.9c0-7.3.7-13.3 2.2-17.7 1.5-4.5 3.8-7.7 7-9.7s7.3-3.1 12.4-3.1c5 0 9.1 1 12.1 3.1s5.3 5.3 6.7 9.7 2.1 10.3 2.1 17.6v9.9c0 7.3-.7 13.1-2.1 17.5s-3.6 7.6-6.7 9.7c-3.1 2-7.3 3.1-12.5 3.1-5.4.1-9.6-1-12.7-3zM245.2 89c.9-2.2 1.3-5.9 1.3-10.9V56.8c0-4.9-.4-8.5-1.3-10.7-.9-2.3-2.4-3.4-4.5-3.4s-3.5 1.1-4.4 3.4-1.3 5.8-1.3 10.7v21.3c0 5 .4 8.7 1.2 10.9s2.3 3.3 4.5 3.3c2.1 0 3.6-1.1 4.5-3.3zm219.2-16.3v3.5l.4 9.9c.3 2.2.8 3.8 1.6 4.8s2.1 1.5 3.8 1.5c2.3 0 3.9-.9 4.7-2.7.9-1.8 1.3-4.8 1.4-8.9l13.3.8c.1.6.1 1.4.1 2.4 0 6.3-1.7 11-5.2 14.1s-8.3 4.7-14.6 4.7c-7.6 0-12.9-2.4-15.9-7.1s-4.6-12.1-4.6-22V61.6c.34-17 3.33-29.45 20.9-29.5 5.3 0 9.3 1 12.1 2.9s4.8 4.9 6 9 1.7 9.7 1.7 16.9v11.7h-25.7zm2-28.8c-.8 1-1.3 2.5-1.6 4.7s-.4 10-.4 10v4.9h11.2v-4.9c0 4.9-.1-7.7-.4-10s-.8-3.9-1.6-4.8-2-1.4-3.6-1.4c-1.7.1-2.9.6-3.6 1.5zM190.5 71.4L173 8.2h15.3s7.15 31.7 9.6 46.6h.4c2.78-15.82 9.8-46.6 9.8-46.6h15.3l-17.7 63.1v30.3h-15.1V71.4z"/><path id="A" d="M311.5 33.4v68.3h-12l-1.3-8.4h-.3c-3.3 6.3-8.2 9.5-14.7 9.5-11.77-.03-13.08-10-13.2-18.4v-51h15.4v50.1c0 3 .3 5.2 1 6.5 1.42 2.78 5.1 2.07 7.1.7a8 8 0 0 0 2.7-3.1V33.4z" fill="white"/><path d="M353.3 20.6H338v81.1h-15V20.6h-15.3V8.2h45.5v12.4zm87.9 23.7c-.9-4.3-2.4-7.4-4.5-9.4-2.1-1.9-4.9-2.9-8.6-2.9a14.1 14.1 0 0 0-7.9 2.4c-2.5 1.6-4.3 3.7-5.7 6.3h-.1v-36h-14.8v96.9h12.7l1.6-6.5h.3a14 14 0 0 0 5.3 5.5c2.4 1.3 5 2 7.9 2 5.2 0 9-2.4 11.5-7.2 2.4-4.8 3.7-12.3 3.7-22.4V62.2c0-7.6-.5-13.6-1.4-17.9zm-14.1 27.9c0 5-.2 8.9-.6 11.7s-1.1 4.8-2.1 6-2.3 1.8-3.9 1.8c-3.1-.1-4.86-1.5-6.1-3.6V49.3c.5-1.9 1.4-3.4 2.7-4.6 2.2-2.47 5.96-2.5 7.7 0 .9 1.2 1.4 3.3 1.8 6.2.3 2.9.5 7 .5 12.4z"/></g><use xlink:href="#A" x="78.9"/></svg></a>
            
        </div>
        <div id="search-container">
            <form>
                <input type="search" name="search" id="search" placeholder="Search">
                <button type="submit" class="material-icons icon-color icon-search-size">search</button>
            </form>
            <div>
                <span class="material-icons icon-color icon-size">mic</span>
            </div>
        </div>
        <div id="user-container">
            <span class="material-icons icon-color icon-size">video_call</span>
            <span class="material-icons icon-color icon-size">apps</span>
            <span class="material-icons icon-color icon-size">notifications</span>
            <img src="./assets/images/user.jpg" alt="">
        </div>
    </section>
    <span class="gray-line"></span>
    <section id="lowerNav">
        <div id="hamburger-container">
            <span (click)="toggleNav()" class="material-icons icon-color icon-size">menu</span>
        </div>
        <div id="nav-items-container">
            <a routerLink="/home">
                <div>
                    <span class="material-icons icon-color icon-size" [routerLinkActive]="['is-active']">home</span>
                    <p [hidden]="isHidden" class="icon-text" [routerLinkActive]="['is-active']">Home</p>
                </div>
            </a>
            <div>
                <span class="material-icons icon-color icon-size">explore</span>
                <p [hidden]="isHidden" class="icon-text">To explore</p>
            </div>
            <a routerLink="/subs">
                <div>
                    <span class="material-icons icon-color icon-size" [routerLinkActive]="['is-active']">subscriptions</span>
                    <p [hidden]="isHidden" class="icon-text" [routerLinkActive]="['is-active']">Subscriptions</p>
                </div>
            </a>
            <div>
                <span class="material-icons icon-color icon-size">video_library</span>
                <p [hidden]="isHidden" class="icon-text">Library</p>
            </div>
        </div>
    </section>
    <div [hidden]="isHidden">
        <section id="lowerNav-dropdown-container">
            <div>
                <span class="material-icons icon-color icon-size">history</span>
                <p>Historical</p>
            </div>
            <div>
                <span class="material-icons icon-color icon-size">slideshow</span>
                <p>Your videos</p>
            </div>
            <div>
                <span class="material-icons icon-color icon-size">theaters</span>
                <p>Your films</p>
            </div>
            <div>
                <span class="material-icons icon-color icon-size">watch_later</span>
                <p>To watch later</p>
            </div>
            <div>
                <span class="material-icons icon-color icon-size">theaters</span>
                <p>Movies</p>
            </div>
            <div>
                <span class="material-icons icon-color icon-size">games</span>
                <p>Video games</p>
            </div>
            <div>
                <span class="material-icons icon-color icon-size">stream</span>
                <p>Live</p>
            </div>
            <div>
                <span class="material-icons icon-color icon-size">emoji_events</span>
                <p>Sports</p>
            </div>
    </section>
    </div>
</nav>
